import { UserContext } from "context/UserContext";
import { useContext } from "react";
import {
  FaArrowCircleDown,
  FaArrowCircleUp,
  FaAt,
  FaBuilding,
  FaCalculator,
  FaChartArea,
  FaChartLine,
  FaChartPie,
  FaCog,
  FaCogs,
  FaCoins,
  FaCreditCard,
  FaCubes,
  FaDollarSign,
  FaExchangeAlt,
  FaFileImport,
  FaFlag,
  FaFolderOpen,
  FaHandshake,
  FaHome,
  FaIdCard,
  FaList,
  FaLock,
  FaMinusCircle,
  FaPlusCircle,
  FaRegCalendarAlt,
  FaRegCalendarCheck,
  FaRegListAlt,
  FaStickyNote,
  FaStoreAlt,
  FaTachometerAlt,
  FaTruck,
  FaUserAlt,
  FaUsers,
  FaWallet,
  FaUserShield,
} from "react-icons/fa";
import { SideBarItem } from "types/sideBarItem/SideBarItemType";

export const ABAS: SideBarItem[] = [
  {
    id: 0,
    titulo: "Visão Geral",
    icone: <FaCubes />,
    rota: "/",
    isV1: true,
    subitem: [],
    isContextoGlobal: true,
  },

  {
    id: 1,
    titulo: "Condomínio",
    icone: <FaBuilding />,
    rota: "/#",
    isV1: true,
    permissoes: ["dadosCondominio"],
    subitem: [
      {
        id: 0,
        titulo: "Dados do condomínio",
        icone: <FaBuilding />,
        rota: "/condominio",
        isV1: true,
        permissoes: ["dadosCondominio"],
        isContextoGlobal: true,
      },
      {
        id: 1,
        titulo: "Unidade",
        icone: <FaHome />,
        rota: "/unidade",
        isV1: true,
        permissoes: ["unidade"],
        isContextoGlobal: true,
      },
      {
        id: 2,
        titulo: "Contas",
        icone: <FaCreditCard />,
        rota: "/conta-bancaria",
        isV1: true,
        permissoes: ["contas"],
        isContextoGlobal: true,
      },
      {
        id: 3,
        titulo: "Plano de contas",
        icone: <FaList />,
        rota: "/plano-contas",
        isV1: true,
        permissoes: ["planoContas"],
        isContextoGlobal: true,
      },
      {
        id: 4,
        titulo: "Responsável Legal",
        icone: <FaIdCard />,
        rota: "/responsavel-legal",
        isV1: true,
        permissoes: ["responsavelLegal"],
        isContextoGlobal: true,
      },
    ],
  },

  {
    id: 2,
    titulo: "Receita",
    icone: <FaArrowCircleUp />,
    rota: "/#",
    isV1: true,
    permissoes: ["lancamentoArrecadacao", "dadosContaReceber", "leituraConsumo", "abatimento", "acordo", "cliente"],
    subitem: [
      {
        id: 0,
        titulo: "Arrecadações",
        icone: <FaChartLine />,
        rota: "/arrecadacao",
        isV1: true,
        permissoes: ["lancamentoArrecadacao"],
        isContextoGlobal: true,
      },
      {
        id: 1,
        titulo: "Contas a receber",
        icone: <FaPlusCircle />,
        rota: "/contas-receber",
        isV1: true,
        permissoes: ["dadosContaReceber"],
        isContextoGlobal: true,
      },
      {
        id: 2,
        titulo: "Leitura de consumo",
        icone: <FaTachometerAlt />,
        rota: "/leitura-consumo",
        isV1: true,
        permissoes: ["leituraConsumo"],
        isContextoGlobal: true,
      },
      {
        id: 3,
        titulo: "Abatimento",
        icone: <FaExchangeAlt />,
        rota: "/abatimento",
        isV1: true,
        permissoes: ["abatimento"],
        isContextoGlobal: true,
      },
      {
        id: 4,
        titulo: "Acordo",
        icone: <FaHandshake />,
        rota: "/acordo",
        isV1: true,
        permissoes: ["acordo"],
        isContextoGlobal: true,
      },
      {
        id: 5,
        titulo: "Cliente",
        icone: <FaUsers />,
        rota: "/cliente",
        isV1: true,
        permissoes: ["cliente"],
        isContextoGlobal: true,
      },
    ],
  },

  {
    id: 3,
    titulo: "Despesa",
    icone: <FaArrowCircleDown />,
    rota: "/#",
    isV1: true,
    permissoes: ["dadosContasPagar", "gerenciarBordero", "fornecedor", "imposto", "cheques"],
    subitem: [
      {
        id: 0,
        titulo: "Contas a pagar",
        icone: <FaMinusCircle />,
        rota: "/contas-pagar",
        isV1: true,
        permissoes: ["dadosContasPagar"],
        isContextoGlobal: true,
      },
      {
        id: 1,
        titulo: "EFD - Reinf",
        icone: <FaFileImport />,
        rota: "/efd-reinf",
        isV1: true,
        permissoes: ["dadosContasPagar"],
        isContextoGlobal: true,
      },
      {
        id: 2,
        titulo: "Fornecedor",
        icone: <FaTruck />,
        rota: "/fornecedor",
        isV1: true,
        permissoes: ["fornecedor"],
        isContextoGlobal: true,
      },
      {
        id: 3,
        titulo: "Imposto",
        icone: <FaRegCalendarCheck />,
        rota: "/imposto",
        isV1: true,
        permissoes: ["imposto"],
        isContextoGlobal: true,
      },
      {
        id: 4,
        titulo: "Cheques",
        icone: <FaRegListAlt />,
        rota: "/cheques",
        isV1: true,
        permissoes: ["cheques"],
        isContextoGlobal: true,
      },
      {
        id: 5,
        titulo: "Group Pay",
        icone: <FaDollarSign />,
        rota: "/group-pay",
        isV1: false,
        isContextoGlobal: false,
      },
    ],
  },

  {
    id: 4,
    titulo: "Financeiro",
    icone: <FaCalculator />,
    rota: "/#",
    isV1: true,
    permissoes: [
      "previsaoOrcamentaria",
      "transferenciaBancaria",
      "fechamento",
      "conciliacaoBancaria",
      "dadosPastaPrestacaoContas",
      "processos",
      "visualizarDetalhesProcesso",
      "agendamento",
      "gestaoCobrancas",
      "iniciarAcordoGestaoCobranca",
    ],
    subitem: [
      {
        id: 0,
        titulo: "Previsão orçamentária",
        icone: <FaChartArea />,
        rota: "/previsao-orcamentaria",
        isV1: true,
        permissoes: ["previsaoOrcamentaria"],
        isContextoGlobal: true,
      },
      {
        id: 1,
        titulo: "Transferências",
        icone: <FaExchangeAlt />,
        rota: "/transferencia-bancaria",
        isV1: true,
        permissoes: ["transferenciaBancaria"],
        isContextoGlobal: true,
      },
      {
        id: 2,
        titulo: "Fechamento do Mês",
        icone: <FaLock />,
        rota: "/fechamento",
        isV1: true,
        permissoes: ["fechamento"],
        isContextoGlobal: true,
      },
      {
        id: 3,
        titulo: "Conciliação bancária",
        icone: <FaWallet />,
        rota: "/conciliacao-bancaria",
        isV1: true,
        permissoes: ["conciliacaoBancaria"],
        isContextoGlobal: true,
      },
      {
        id: 4,
        titulo: "Prestação de contas",
        icone: <FaFolderOpen />,
        rota: "/pasta-prestacao-contas",
        isV1: true,
        permissoes: ["dadosPastaPrestacaoContas"],
        isContextoGlobal: true,
      },
      {
        id: 5,
        titulo: "Gestão de cobranças",
        icone: <FaCoins />,
        rota: "/gestao-cobrancas",
        isV1: false,
        permissoes: [
          "processos",
          "visualizarDetalhesProcesso",
          "agendamento",
          "gestaoCobrancas",
          "iniciarAcordoGestaoCobranca",
        ],
        isContextoGlobal: true,
      },
    ],
  },

  {
    id: 10,
    titulo: "Assinatura digital",
    icone: <FaUserShield />,
    rota: "/#",
    isV1: false,
    permissoes: [
      "configuracaoCondominio",
      "statusAssinatura",
      "configuracaoDocumentos",
      "assinaturaDigital",
      "cancelarAssinaturaDigital"
    ],
    subitem: [
      {
        id: 0,
        titulo: "Configurar assinaturas",
        icone: <FaUserShield />,
        rota: "/assinatura-digital/configuracao",
        isV1: false,
        permissoes: [
          "configuracaoCondominio", 
          "configuracaoDocumentos"
        ],
        isContextoGlobal: true,
      },
      {
        id: 1,
        titulo: "Gestão de assinaturas",
        icone: <FaUserShield />,
        rota: "/assinatura-digital/gestao",
        isV1: false,
        permissoes: ["assinaturaDigital"],
        isContextoGlobal: true,
      },
    ],
  },

  {
    id: 11,
    titulo: "Assinatura digital",
    icone: <FaUserShield />,
    rota: "/assinatura-digital/proposta-comercial",
    isV1: false,
    permissoes: ["dadosCondominio"],
  },

  {
    id: 5,
    titulo: "Relatórios",
    icone: <FaChartPie />,
    rota: "/relatorios",
    isV1: true,
    permissoes: [
      "relatorioBalancete",
      "relatorioDespesasDetalhadasClasse",
      "relatorioDespesasConsolidadasClasse",
      "relatorioDespesasDetalhadasFornecedor",
      "relatorioDespesasConsolidadasFornecedor",
      "relatorioDespesasLancamento",
      "relatorioMovimentacaoConta",
      "relatorioPrevistoRealizadoAcumulado",
      "relatorioPrevistoRealizadoMensal",
      "relatorioPrevisaoFluxoCaixaDiario",
      "relatorioPrevisaoFluxoCaixaMensal",
      "relatorioCertidaoNegativaDebito",
      "relatorioDetalhadoReceitas",
      "relatorioConsolidadoReceitas",
      "relatorioConsolidadoAcordo",
      "relatorioDetalhadoAcordo",
      "relatorioDetalhadoInadimplencia",
      "relatorioConsolidadoInadimplencia",
      "relatorioDadosCadastraisCondominos",
      "relatorioDespesasConsolidadasClasse",
      "relatorioDespesasDetalhadasFornecedor",
      "relatorioDespesasConsolidadasFornecedor",
      "relatorioDespesasLancamento",
      "relatorioPrevistoRealizadoMensal",
      "relatorioPrevisaoFluxoCaixaDiario",
      "relatorioPrevisaoFluxoCaixaMensal",
      "relatorioCertidaoNegativaDebito",
      "relatorioCartaCobranca",
      "relatorioTransferencia",
    ],
    subitem: [],
  },

  {
    id: 6,
    titulo: "Configuração",
    icone: <FaCog />,
    rota: "/#",
    isV1: true,
    permissoes: ["usuarios", "gestaoFeriados", "gestaoEmails", "consumo", "grupoAcesso", "parametros"],
    subitem: [
      {
        id: 0,
        titulo: "Usuários",
        icone: <FaUserAlt />,
        rota: "/usuario",
        isV1: true,
        permissoes: ["usuarios"],
        isContextoGlobal: true,
      },
      {
        id: 1,
        titulo: "Grupo de acesso",
        icone: <FaUserAlt />,
        rota: "/grupo-acesso",
        isV1: true,
        permissoes: ["grupoAcesso"],
        isContextoGlobal: true,
      },
      {
        id: 2,
        titulo: "Parâmetros",
        icone: <FaFlag />,
        rota: "/parametros",
        isV1: true,
        permissoes: ["parametros"],
        isContextoGlobal: true,
      },
      {
        id: 3,
        titulo: "Gestão de Feriados",
        icone: <FaRegCalendarAlt />,
        rota: "/feriado",
        isV1: true,
        permissoes: ["gestaoFeriados"],
        isContextoGlobal: true,
      },
      {
        id: 4,
        titulo: "Gestão de e-mails",
        icone: <FaAt />,
        rota: "/email",
        isV1: true,
        permissoes: ["gestaoEmails"],
        isContextoGlobal: true,
      },
      {
        id: 5,
        titulo: "Consumo",
        icone: <FaCogs />,
        rota: "/configuracao-tipo-consumo",
        isV1: true,
        permissoes: ["consumo"],
        isContextoGlobal: true,
      },
      {
        id: 6,
        titulo: "Gestão Group",
        icone: <FaUserAlt />,
        rota: "/gestao-vinteum",
        isV1: true,
        isContextoGlobal: true,
      },
    ],
  },

  {
    id: 7,
    titulo: "COM21",
    icone: <FaHome />,
    rota: "/onboarding-espaco",
    isV1: true,
    permissoes: ["espaco", "configurarCom21"],
    filtro: "naoPossuiCom21",
  },
  {
    id: 8,
    titulo: "COM21",
    icone: <FaHome />,
    rota: "/#",
    isV1: true,
    permissoes: ["espaco", "configurarCom21"],
    filtro: "possuiCom21",
    subitem: [
      {
        id: 0,
        icone: <FaStoreAlt />,
        titulo: "Espaços",
        rota: "/configurar-espacos",
        isV1: true,
        permissoes: ["espaco"],
        isContextoGlobal: true,
      },
      {
        id: 1,
        icone: <FaCog />,
        titulo: "Configurar COM21",
        rota: "/configurar-com21",
        isV1: true,
        permissoes: ["configurarCom21"],
        isContextoGlobal: true,
      },
    ],
  },
  //TODO FAZER ENV PARA SABER SE BASE DO CONHECIMENTO ESTPA HABILITADA
  {
    id: 9,
    titulo: "Central de ajuda",
    icone: <FaStickyNote />,
    rota: "/base-conhecimento",
    isV1: true,
    subitem: [],
  },
];

export default ABAS;
